// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__213HG","rotation":"SmallLoader_rotation__IbZRp"};